export default {
  install(Vue) {
    Vue.prototype.$chartColours = {
      allowed: "#4BA7EE",
      blocked: "#DE3617",
    };

    /**
     * Creates custom HTML legend
     * @param {chartjs chart} chart Chartjs chart
     * @returns {string} Chart legend HTML
     */
    Vue.prototype.$generateLegendHTML = function (chart) {
      return `<div class="t-legend text-center my-2">
            ${chart.legend.legendItems
              .map((item, idx) => {
                return `<span class="d-inline-flex align-items-center ${
                  idx !== chart.legend.legendItems.length - 1 ? "mr-5" : ""
                }"><span class="mr-1 d-inline-block rounded-circle" style="width:1rem;height:1rem;background:${
                  item.fillStyle
                }"></span> ${item.text}</span>`;
              })
              .join("")}
          </div>
          `;
    };

    /**
     * Method used to generate custom HTML tooltip
     * for use with Chartjs
     * @param {chartjs model} tooltipModel
     * @returns Renders tooltip
     */
    Vue.prototype.$chartTooltip = function (tooltipModel) {
      const styles = {
        padding: "padding: 4px;",
        container: `
          background:${tooltipModel.backgroundColor};
          border-radius: ${tooltipModel.cornerRadius}px;
          border: 1px solid ${tooltipModel.borderColor};
          box-shadow: 3px 6px 23px -5px rgba(0,0,0,0.43);
        `,
        header: `
          background: ${tooltipModel.borderColor};
          font-size: ${tooltipModel.titleFontSize}px;
        `,
        listItems: `
          background: inherit;
        `,
        listItemIndicators: (colors) => `
          display: inline-block;
          background: ${colors.backgroundColor};
          border: 2px;
          border-radius: 50%;
          width: 10px;
          height: 10px;
          margin-right: 8px;
        `,
      };
      let tooltipEl = document.getElementById("chartjs-tooltip");

      if (!tooltipEl) {
        tooltipEl = document.createElement("div");
        tooltipEl.id = "chartjs-tooltip";
        tooltipEl.innerHTML = `<div style="${styles.container}"></div>`;
        document.body.appendChild(tooltipEl);
      }

      if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
      }

      tooltipEl.classList.remove("above", "below", "no-transform");
      if (tooltipModel.yAlign) {
        tooltipEl.classList.add(tooltipModel.yAlign);
      } else {
        tooltipEl.classList.add("no-transform");
      }

      function getBody(bodyItem) {
        return bodyItem.lines;
      }

      if (tooltipModel.body) {
        const titleLines = tooltipModel.title || [];
        const bodyLines = tooltipModel.body.map(getBody);
        let innerHtml = "";
        if (titleLines.length) {
          innerHtml = `<div style="${styles.header}${styles.padding}">`;

          titleLines.forEach(function (title) {
            innerHtml += "<span>" + title + "</span>";
          });
          innerHtml += "</div>";
        }

        bodyLines.forEach(function (body, i) {
          let parsedInteger = parseInt(i);
          const colors = tooltipModel.labelColors[`${parsedInteger}`];
          let span = `<span style="${styles.listItemIndicators(
            colors
          )}"></span>`;
          innerHtml += `<div style="${styles.listItems}${styles.padding}">${span}${body}</div>`;
        });
        innerHtml += "</div>";

        const tableRoot = tooltipEl.querySelector("div");
        tableRoot.innerHTML = innerHtml;
      }

      const position = this._chart.canvas.getBoundingClientRect();

      tooltipEl.style.opacity = 1;
      tooltipEl.style.position = "absolute";
      tooltipEl.style.left =
        position.left + window.pageXOffset + tooltipModel.caretX + "px";
      tooltipEl.style.top =
        position.top + window.pageYOffset + tooltipModel.caretY + "px";
      tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
      tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px";
      tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
      tooltipEl.style.padding =
        tooltipModel.yPadding + "px " + tooltipModel.xPadding + "px";
      tooltipEl.style.pointerEvents = "none";
    };
  },
};
